function resolveToggleOpenTarget(target, ele) {
  if (target === '$parent') {
    return ele.parent();
  }
  
  return jQuery(target);
}
  
jQuery(function() {
  jQuery('[data-toggle-open]').on('click', function() {
    var $this = jQuery(this);
    var target = $this.data('toggle-open');
    var $target = resolveToggleOpenTarget(target, $this);
    $target.toggleClass('open');
  });
});